import React from 'react';
import { FaRegFile } from 'react-icons/fa6';
import './FilesList.scss';

interface IFilesListProps {
    files: string[];
    title: string;
    onFileClick: (file: string) => void;
}

export const FilesList: React.FC<IFilesListProps> = ({ title, files, onFileClick }) => {
    return (
        <div className='save-files-list'>
            <h5 className='save-files-list__title'>{title}</h5>
            <div className='save-files-list__list'>
                {files?.map((file) => (
                    <div
                        key={file?.substring(0, 7)}
                        className='save-files-list__list__file'
                        onClick={() => onFileClick(file)}
                    >
                        <FaRegFile className='save-files-list__list__file__icon' />
                        <p>{file}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
